import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './TikTokBrandIdMapper.module.scss';

export function TikTokNoBrands({ onRefresh, onSkip }) {
  return (
    <div className={cn(styles.wrapper, styles.noBrands)}>
      <h3>
        Our system has not detected any <strong>authorized brands</strong> on your TTS.
        <br />
        <a
          href="https://seller-us.tiktok.com/university/essay?knowledge_id=2419888845686570&role=1&course_type=1&from=search&identity=1"
          target="_blank"
          rel="noopener noreferrer"
        >
          Please add an authorized brand
        </a>{' '}
        or skip this step.
      </h3>

      <div className={styles.actions}>
        <button onClick={onRefresh}>Refresh</button>
        <button onClick={onSkip}>Skip</button>
      </div>
    </div>
  );
}

TikTokNoBrands.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
};
